import { gql } from '@apollo/client';

/**
 * 标签动作执行历史 (task_execution 留痕, 时间倒序)。
 */
export const LIST_AOI_BIZ_TAG_ACTION_RUNS = gql`
  query ListAoiBizTagActionRuns($aoiId: Long!, $action: String!, $limit: Int!) {
    listAoiBizTagActionRuns(aoiId: $aoiId, action: $action, limit: $limit) {
      taskId
      mode
      status
      startedAt
      endedAt
      message
    }
  }
`;

export interface AoiBizTagActionRun {
    /** Long 标量运行时是字符串 */
    taskId: number | string;
    /** EXECUTE (历史数据可能有 ROLLBACK, 仅展示) */
    mode: string;
    /** 1=初始化 / 2=运行中 / 3=成功 / 4=失败 */
    status: number;
    startedAt: string | null;
    endedAt: string | null;
    /** 执行摘要 JSON (候选数 / 删除条数 / 失败原因; 历史 ROLLBACK 留痕含恢复条数); 别名 id 全量列表后端已去掉, 不下发 */
    message: string | null;
}

export interface ListAoiBizTagActionRunsResponse {
    listAoiBizTagActionRuns: AoiBizTagActionRun[];
}
